<template>
  <div>
    <div class="page-header clear-filter" filter-color="orange">
      <div class="container">
        <h2 class="title">Ingresa tus datos para procesar tu pedido</h2>
        <!-- <p class="description"></p> -->
        <div class="row">
          <div class="col-lg-6 text-center ml-auto mr-auto col-md-8">
            <fg-input
              class="input-lg"
              placeholder="Nombre"
              v-model="form.firstName"
              addon-left-icon="now-ui-icons users_circle-08"
            >
            </fg-input>
            <fg-input
              class="input-lg"
              placeholder="Numero Celular"
              v-model="form.email"
              addon-left-icon="now-ui-icons tech_mobile"
            >
            </fg-input>
            <fg-input
              class="input-lg"
              placeholder="Correo Electronico"
              v-model="form.email"
              addon-left-icon="now-ui-icons ui-1_email-85"
            >
            </fg-input>
            <fg-input
              class="input-lg"
              placeholder="Dirección"
              v-model="form.email"
              addon-left-icon="now-ui-icons location_pin"
            >
            </fg-input>
          </div>
        </div>
         <h4>Continua con tu proceso de compra</h4>
           <i class="now-ui-icons arrows-1_minimal-down"></i>
      </div>
     
    </div>
    <!-- <div class="section"> -->
      <div class="container">
        <h3 class="title-pedido">Revisa tu pedido</h3>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="Categoria" width="180">
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ scope.row.categoria }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Nombre" width="180">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>Nombre: {{ scope.row.nombre }}</p>
                <p>Precio: {{ scope.row.precio }}</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">{{ scope.row.nombre }}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
           <el-table-column label="Imagen" width="180">
            <template slot-scope="scope">
              <img :src="scope.row.img" alt="">
            </template>
          </el-table-column>
          <el-table-column label="Operaciones">
            <template slot-scope="scope">
              <el-input-number controls-position="right" v-model="num4" :min="1" :max="10" size="mini"></el-input-number>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index)"
                >Eliminar</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="send-button">
          <n-button type="primary" round block size="lg">
            Enviar información de Pedido
          </n-button>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>
<script>
import { Button, FormGroupInput } from "@/components";
export default {
  data() {
    return {
      num4: 1,
      form: {
        firstName: "",
        email: "",
        message: "",
      },
      tableData: this.$store.state.Compra
    };
  },
  methods: {
    handleEdit(index, row) {
      
    },
    handleDelete(i) {
      this.$store.commit("delete", i);
    },
  },
  name: "Carrito",
  bodyClass: "profile-page",
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
  },
};
</script>
<style scoped>
.title-pedido{
  font-weight: 700;
  text-align: center;
  margin-top:15px;
}
</style>
